import { render, staticRenderFns } from "./3ActivityRegistration.vue?vue&type=template&id=15094de3&scoped=true&"
import script from "./3ActivityRegistration.vue?vue&type=script&lang=js&"
export * from "./3ActivityRegistration.vue?vue&type=script&lang=js&"
import style0 from "./3ActivityRegistration.vue?vue&type=style&index=0&id=15094de3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15094de3",
  null
  
)

export default component.exports